import { render, staticRenderFns } from "./materDispose_Detail.vue?vue&type=template&id=5d70aa4e&"
import script from "./materDispose_Detail.vue?vue&type=script&lang=js&"
export * from "./materDispose_Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports